import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          {/* Custom Logo Design: CARGO + Marketing Icon + ENGAGE */}
          <Link to="/" className="logo" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            textDecoration: 'none',
            fontFamily: 'Space Grotesk, sans-serif',
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#ffffff'
          }}>
            <span style={{color: '#ffffff'}}>CARGO</span>
            
            {/* Marketing/Campaign Megaphone Icon */}
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{flexShrink: 0}}>
              {/* Megaphone body */}
              <path d="M19 4L5 8V16L19 20V4Z" fill="#06b6d4"/>
              <path d="M5 8L3 9V15L5 16" fill="#0891b2"/>
              {/* Sound waves */}
              <path d="M20 8C21 9 21 11 21 12C21 13 21 15 20 16" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
              <path d="M22 6C23.5 7.5 23.5 10.5 23.5 12C23.5 13.5 23.5 16.5 22 18" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
              {/* Handle */}
              <circle cx="5" cy="12" r="2" fill="#0891b2"/>
            </svg>
            
            <span style={{color: '#06b6d4'}}>ENGAGE</span>
          </Link>
          
          {/* Unique Menu Structure */}
          <ul className="nav-links">
            <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>Platform</Link></li>
            <li><Link to="/services" className={location.pathname === '/services' ? 'active' : ''}>Solutions</Link></li>
            <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>Company</Link></li>
            <li><Link to="/compliance" className={location.pathname === '/compliance' ? 'active' : ''}>Trust & Safety</Link></li>
            <li><Link to="/support" className={location.pathname === '/support' ? 'active' : ''}>Resources</Link></li>
          </ul>
          
          {/* CTA Button in Header */}
          <Link to="/contact" style={{
            padding: '0.625rem 1.5rem',
            background: 'linear-gradient(135deg, #06b6d4, #0891b2)',
            color: 'white',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '0.875rem',
            transition: 'all 0.3s ease',
            boxShadow: '0 0 20px rgba(6, 182, 212, 0.3)'
          }}>
            Get Started
          </Link>
          
          <div className="mobile-menu" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          
          <div className={`nav-mobile ${mobileMenuOpen ? 'active' : ''}`}>
            <ul>
              <li><Link to="/" onClick={() => setMobileMenuOpen(false)}>Platform</Link></li>
              <li><Link to="/services" onClick={() => setMobileMenuOpen(false)}>Solutions</Link></li>
              <li><Link to="/about" onClick={() => setMobileMenuOpen(false)}>Company</Link></li>
              <li><Link to="/compliance" onClick={() => setMobileMenuOpen(false)}>Trust & Safety</Link></li>
              <li><Link to="/support" onClick={() => setMobileMenuOpen(false)}>Resources</Link></li>
              <li><Link to="/contact" onClick={() => setMobileMenuOpen(false)}>Get Started</Link></li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
